import { render, staticRenderFns } from "./mobileCenter.vue?vue&type=template&id=6ccbc4a8&scoped=true&"
import script from "./mobileCenter.vue?vue&type=script&lang=js&"
export * from "./mobileCenter.vue?vue&type=script&lang=js&"
import style0 from "./mobileCenter.vue?vue&type=style&index=0&id=6ccbc4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbc4a8",
  null
  
)

export default component.exports